import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaTimes,
  FaAngleDown,
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import Nav from "./Nav";
import { Home, Search } from "lucide-react";
import { CgProfile } from "react-icons/cg";
import SearchPopup from "../../elements/search-popup/SearchPopup";

const MobileMenu = ({ MobileHandler }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // Helper function to handle both navigation and closing the menu
  const handleLinkClick = () => {
    // Close the mobile menu when any link is clicked
    MobileHandler();
  };
  return (
    <div className="mobilemenu-popup">
      <div className="mobilemenu-inner">
        <div className="mobilemenu-header">
          <div className="mobile-nav-logo">
            <Link to={process.env.PUBLIC_URL + "/"}>
              <img
                className="light-mode"
                src={process.env.PUBLIC_URL + "/images/ucwf-logo-header.png"}
                alt="Site Logo"
              />
              <img
                className="dark-mode"
                src={process.env.PUBLIC_URL + "/images/logo-3.svg"}
                alt="Site Logo"
              />
            </Link>
          </div>
          <button className="mobile-menu-close" onClick={MobileHandler}>
            <FaTimes />
          </button>
        </div>
        <div className="mobilemenu-body">
          <nav className="mainmenu-nav">
            <ul className="mainmenu">
              <li className="menu-item-has-children">
                <Link
                  to="/"
                  onClick={handleLinkClick}
                  style={{ color: "#562b7a" }}
                >
                  Home
                </Link>
              </li>

              <li className="menu-item-has-children">
                <div
                  className="menu-link-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Link to="/who-we-are" style={{ color: "#562b7a", flex: 1 }}>
                    About Us
                  </Link>
                  <span
                    className="dropdown-toggle"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      // Find the closest submenu and toggle it
                      const submenu = e.currentTarget
                        .closest(".menu-item-has-children")
                        .querySelector(".axil-submenu");
                      if (submenu) submenu.classList.toggle("active");
                    }}
                    style={{ padding: "10px", cursor: "pointer" }}
                  >
                    {/* <FaAngleDown /> */}
                  </span>
                </div>
                <ul className="axil-submenu">
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                      Who We Are
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/mission-vision"}>
                      Mission & Vision
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/testimonials"}>
                      Testimonials
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/health-safety"}>
                      Health & Safety
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/sustainability"}>
                      Sustainability{" "}
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/smart-tech"}>
                      Smart Tech{" "}
                    </Link>
                  </li>
                </ul>
              </li>

              {/* // For MobileMenu.js - Update the Services menu item */}
              <li className="menu-item-has-children">
                <div
                  className="menu-link-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Link to="/services" style={{ color: "#562b7a", flex: 1 }}>
                    Services
                  </Link>
                  <span
                    className="dropdown-toggle"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      // Find the closest submenu and toggle it
                      const submenu = e.currentTarget
                        .closest(".menu-item-has-children")
                        .querySelector(".axil-submenu");
                      if (submenu) submenu.classList.toggle("active");
                    }}
                    style={{ padding: "10px", cursor: "pointer" }}
                  >
                    {/* <FaAngleDown /> */}
                  </span>
                </div>
                <ul className="axil-submenu">
                  <li className="menu-item-has-children">
                    <Link to="/service/ifm-services" onClick={handleLinkClick}>
                      IFM Services
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/service/hard-services" onClick={handleLinkClick}>
                      Hard Services
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/service/soft-services" onClick={handleLinkClick}>
                      Soft Services
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link
                      to="/service/security-services"
                      onClick={handleLinkClick}
                    >
                      Security Services
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link
                      to="/service/specialized-services"
                      onClick={handleLinkClick}
                    >
                      Specialized Services
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="menu-item-has-children">
                <Link to="/industry" style={{ color: "#562b7a" }}>
                  Industries We Serve
                  {/* <FaAngleDown /> */}
                </Link>
                {/* <ul className="axil-submenu">
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/commercial-properties"}>Commercial Properties</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/residential-properties"}>Residential Properties</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/master-communities"}>Master Communities</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/malls"}>Malls & Retail</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/hospitality"}>Hospitality</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/villas-apartments"}>Villas and Apartments</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/industry/warehouses"}>Warehouses</Link></li>
                                </ul> */}
              </li>
              <li className="menu-item-has-children">
                <Link
                  to={process.env.PUBLIC_URL + "/client-portfolio"}
                  style={{ color: "#562b7a" }}
                >
                  Client Portfolio
                </Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/accreditations " style={{ color: "#562b7a" }}>
                  Accreditations
                </Link>
              </li>
              {/* <li className="menu-item-has-children">
                                <Link to="/" style={{color:  "#562b7a"}}>Support <FaAngleDown /></Link>
                                <ul className="axil-submenu">
                                    <li><Link to={process.env.PUBLIC_URL + "/faqs"}>FAQs</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/terms-conditions"}>Terms & Conditions</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + "/cookie-policy"}>Cookie Policy</Link></li>
                                </ul>
                            </li> */}

              <li className="menu-item-has-children">
                <div
                  className="menu-link-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Link to="/contact-us" style={{ color: "#562b7a", flex: 1 }}>
                    Contact Us
                  </Link>
                  <span
                    className="dropdown-toggle"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      // Find the closest submenu and toggle it
                      const submenu = e.currentTarget
                        .closest(".menu-item-has-children")
                        .querySelector(".axil-submenu");
                      if (submenu) submenu.classList.toggle("active");
                    }}
                    style={{ padding: "10px", cursor: "pointer" }}
                  >
                    {/* <FaAngleDown /> */}
                  </span>
                </div>
                <ul className="axil-submenu">
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/contact-us"}>
                      Contact Us
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/request-quote"}>
                      Request a Quote
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/faqs"}>FAQs</Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/careers"}>
                      Careers
                    </Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to={process.env.PUBLIC_URL + "/cookie-policy"}>
                      Cookie Policy
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>

          {/* Add the action icons section */}
          <div className="mobilemenu-actions">
            <ul
              className="list-unstyled"
              style={{
                display: "flex",
                justifyContent: "space-around",
                padding: "15px 0",
              }}
            >
              {/* <li>
                                <Link to="/" title="Home" style={{ color: "#562b7a" }}>
                                    <Home size={20} />
                                </Link>
                            </li> */}
              <li>
                <a
                  href="https://ucwf.erpradius.com"
                  title="Software"
                  style={{ color: "#562b7a" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CgProfile size={20} />
                </a>
              </li>
              {/* <li>
                                <button
                                    onClick={() => {
                                        // You'll need to pass the search handler from HeaderOne
                                        // For now, this will just close the mobile menu
                                        MobileHandler();
                                    }}
                                    className="search-trigger"
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "#562b7a",
                                        padding: 0
                                    }}
                                >
                                    <Search size={20} />
                                </button>
                            </li> */}
              {/* // In your JSX where the search icon is: */}
              {/* <li className="menu-item-has-children">
                <button
                  onClick={() => setIsSearchOpen(true)}
                  className="search-trigger"
                  style={{
                    background: "none",
                    border: "none",
                    color: "#562b7a",
                    fontWeight: 500,
                    fontSize: "16px",
                    paddingTop: "0px",
                  }}
                >
                  <Search size={20} />
                </button>
              </li>
            
              <SearchPopup
                isOpen={isSearchOpen}
                onClose={() => setIsSearchOpen(false)}
              /> */}
              <li>
                <a
                  href="https://www.facebook.com/people/UCWF-Facilities-Management/100063065238562"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#562b7a" }}
                >
                  <FaFacebookF size={18} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ucwf_fm"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#562b7a" }}
                >
                  <FaInstagram size={18} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/ucwf-facilities-management-services"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#562b7a" }}
                >
                  <FaLinkedin size={18} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileMenu;
